<template>
    <div class="games-grid-empty">
        <h2 class="games-grid-empty__text">Žádné hry jsme pro vybrané filtry nenašli.</h2>
        <WebpImage
            src="/frontend/web/img/games/games-empty.png"
            css-class="games-grid-empty__image"
            width="756"
            height="auto"
            alt="Žádné hry"
        />
    </div>
</template>
<script lang="ts" setup>
import WebpImage from "@sazka/design-system/src/image/webp-image.vue";
</script>
